"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TIMELINE_ITEM_BORDER_BOTTOM = exports.TIMELINE_BORDER = exports.TIMELINE_LAYER_HEIGHT = exports.TIMELINE_PADDING = void 0;
exports.TIMELINE_PADDING = 16;
exports.TIMELINE_LAYER_HEIGHT = 25;
exports.TIMELINE_BORDER = 1;
exports.TIMELINE_ITEM_BORDER_BOTTOM = 1;
